import Vue from "vue";

let requireFile = require.context("../components/", true, /\/*\.vue$/);
requireFile.keys().forEach((fileName) => {
  const moduleConfig = requireFile(fileName);
  const comp = moduleConfig.default || moduleConfig;
  Vue.component(comp.name, comp);
});
